import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import withAuth from '../components/withAuth';

function Learn() {
    return (
        <div id="wrapper">
            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">

              

                  {/* section begin */}
                  <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Learn</h1>
                                    <p><a style={{ color: '#606060' }} href="https://chat.openai.com/g/g-Uuum7X2ru-nft-expert-mintology-developer-support"><i className="fa fa-comment"></i> ChatGPT - Gallery3 Support</a>
                                    </p>                                
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* section close */}

                {/* Section begin */}
                <section aria-label="section" id="section-learn">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>Getting Started</h4>
                                        {/* <p></p> */}
                                        <Link to="/learn-more" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>What's a wallet?</h4>
                                        {/* <p></p> */}
                                        <Link to="/learn-more#2" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>What is an NFT?</h4>
                                        {/* <p></p> */}
                                        <Link to="/learn-more#3" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>What's the point of buying an NFT if I can just download the picture?</h4>
                                        {/* <p></p> */}
                                        <Link to="/learn-more#4" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>How to create a collection?</h4>
                                        {/* <p></p> */}
                                        <Link to="/learn-more#8" className="btn-main learn">Read more</Link>
                                </div>
                            </div>
                           
                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>What is TON blockchain?</h4>
                                        {/* <p></p> */}
                                        <Link to="/learn-more#14" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>How to create a gallery?</h4>
                                        {/* <p>https://blog.mintology.app/2024/03/15/intellectual-property-and-copyrights-in-nfts/ + https://docs.mintology.app/ */}
                                        <Link to="/learn-more#7" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>How to buy Toncoins?</h4>
                                        {/* <p>You can buy Toncoin with a credit or debit card in the Tonkeeper app via the Mercuryo or NeoCrypto services. For more info, check TON's official website.</p> */}
                                        <Link to="/learn-more#9" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                        <h4 className='mb20'>How do I get verified?</h4>
                                        {/* <p>Gallery3 verifies creators on a case-by-case basis to protect collectors. Creators who are verified will have a badge next to their name.
</p> */}                                 <Link to="/learn-more#5" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                <h4 className='mb20'>Intellectual Property and Copyrights</h4>
                                        {/* <p>https://blog.mintology.app/2024/03/15/intellectual-property-and-copyrights-in-nfts/ + https://docs.mintology.app/ */}
                                        <Link to="/learn-more#6" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                <h4 className='mb20'>Glry3 Token</h4>
                                        {/* <p>https://docs.liveart.xyz/web3/art-token/intro */}
                                        <Link to="/learn-more#11" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                <h4 className='mb20'>Protecting your NFT</h4>
                                        {/* <p>https://docs.liveart.xyz/web3/products/digital-art-studio/protecting-your-nft */}
                                        <Link to="/learn-more#10" className="btn-main learn">Read more</Link>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                <h4 className='mb20'>NFT Tickets</h4>
                                        {/* <p>https://docs.liveart.xyz/web3/products/digital-art-studio/protecting-your-nft */}
                                        <Link to="/learn-more#13" className="btn-main learn">Read more</Link>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 mb25">
                                <div className="feature-box f-boxed style-3 text-center">
                                <h4 className='mb20'>How to set up a wallet</h4>
                                        {/* <p>https://docs.liveart.xyz/web3/products/digital-art-studio/protecting-your-nft */}
                                        <Link to="/learn-more#14" className="btn-main learn">Read more</Link>
                                </div>
                            </div>

                        <div>

                    </div>
                        </div>
                    </div>
                </section>
                {/* Section close */}
            </div>

            {/* Footer component */}
            <Footer />
        </div>
    );
}

export default withAuth(Learn);